// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  versonaId: __t.u64().name("versona_id"),
  kind: __t.string(),
  detail: __t.string(),
  at: __t.timestamp(),
});
